import { Injectable } from '@angular/core';
import { ENV } from '@app/env';
import { App, ViewController } from 'ionic-angular';
import { Plan } from '../models/plan.model';
import { SubscriptionCoupon } from '../models/subscription-coupon.model';

// tslint:disable-next-line: ban-types
declare var gtag: Function;
declare var fbq: (...args: any[]) => void;
declare var gtag_report_conversion: Function;

@Injectable()
export class AnalyticsService {
  constructor(private app: App) {}

  init(): void {
    this.listenPageChange();
    try {
      const script1: any = document.createElement('script');
      script1.async = true;
      script1.src = 'https://www.googletagmanager.com/gtag/js?id=' + ENV.gaId;
      document.head.appendChild(script1);

      const script2: any = document.createElement('script');
      script2.innerHTML =
        `
				window.dataLayer = window.dataLayer || [];
				function gtag(){dataLayer.push(arguments);}
				gtag('js', new Date());
				gtag('config', '` +
        ENV.gaId +
        `', {'send_page_view': false});
			`;

      if (ENV.mode == 'PROD') {
        script2.innerHTML += `gtag('config', '` + ENV.registerFinishedConversionTag + `');`;
      }
      document.head.appendChild(script2);

      if (ENV.mode == 'PROD') {
        const script3: any = document.createElement('script');
        script3.innerHTML = `
					function gtag_report_conversion(url) {
						var callback = function () {
							if (typeof(url) != 'undefined') {
								//window.location = url;
							}
						};
						gtag('event', 'conversion', { 'send_to': 'AW-653257022/clOPCLG3qswBEL7Sv7cC', 'event_callback': callback });
						return false;
					}`;
        document.head.appendChild(script3);
        this.initPixel();
      }
    } catch (ex) {
      console.error('Error appending google analytics');
      console.error(ex);
    }
  }

  event(eventName: string, category: string, label?: string, value?: number): void {
    try {
      gtag('event', eventName, {
        event_category: category || '',
        event_label: label || '',
        value: value || 1,
      });
    } catch (error) {
      console.error(error);
    }
  }

  purchaseEvent(subscriptionId: number, plan: Plan, coupon: SubscriptionCoupon): void {
    try {
      const order: any = {
        transaction_id: subscriptionId,
        value: plan.total,
        currency: 'BRL',
        coupon: coupon ? coupon.code : '',
        items: [],
      };
      plan.modules.forEach((module) => {
        if (module.selected) {
          order.items.push({
            item_id: module.id,
            item_name: module.desc,
            price: module.price,
            item_category: 'module',
          });
        }
      });
      gtag('event', 'purchase', order);
    } catch (error) {
      console.error(error);
    }
  }

  registerConversionEvent(): void {
    try {
      // gtag('event', 'conversion', { send_to: APP_CONFIG.GA_TAG_CONVERSION_VALUE });
      gtag_report_conversion('https://app.fastget.com.br/#/establishment-registration');
      fbq('track', 'Lead');
    } catch (error) {
      console.error(error);
    }
  }

  exception(description: string): void {
    try {
      gtag('event', 'exception', {
        description: description,
        fatal: false,
      });
    } catch (error) {
      console.error(error);
    }
  }

  trackView(): void {
    try {
      const path: string = '/' + location.hash;
      console.log(path);
      gtag('event', 'page_view', {
        //page_title: '<Page Title>',
        page_location: path,
      });
      if (ENV.mode == 'PROD') {
        fbq('track', 'PageView');
      }
    } catch (error) {
      console.error(error);
    }
  }

  private listenPageChange(): void {
    this.app.viewDidEnter.subscribe((view: ViewController) => {
      // console.log(view);
      if (view && !view.isOverlay) {
        if (view.instance && !view.instance.alreadyLoaded) {
          view.instance.alreadyLoaded = true;
          setTimeout(() => {
            this.trackView();
          }, 500);
        }
      }
    });
  }

  private initPixel(): void {
    try {
      const pixelFb = document.createElement('script');
      pixelFb.id = 'pixel-script';
      pixelFb.innerHTML = `
				!function(f,b,e,v,n,t,s)
				{if(f.fbq)return;n=f.fbq=function(){n.callMethod?
				n.callMethod.apply(n,arguments):n.queue.push(arguments)};
				if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
				n.queue=[];t=b.createElement(e);t.async=!0;
				t.src=v;s=b.getElementsByTagName(e)[0];
				s.parentNode.insertBefore(t,s)}(window, document,'script',
				'https://connect.facebook.net/en_US/fbevents.js');
				fbq('init', '1637078957072656');
				fbq('track', 'PageView');
			`;
      document.head.appendChild(pixelFb);
    } catch (e) {
      console.error('Error appending PIXEL ID');
      console.error(e);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/analytics.service.ts